import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { updateHomeContent, fetchHomeContent } from '../../api/homeContent';
import 'react-quill/dist/quill.snow.css';

const quillModules = {
  toolbar: [
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['clean'],
  ],
};

const quillFormats = [
  'size',
  'bold',
  'italic',
  'underline',
  'color',
  'list',
  'bullet',
  'align',
];

const AdminHomeContent = () => {
  const [form, setForm] = useState({
    title: '',
    text: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const loadContent = async () => {
      try {
        const data = await fetchHomeContent();
        setForm({
          title: data?.title || '',
          text: data?.text || '',
        });
      } catch (error) {
        console.error('Failed to load home content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  const handleTitleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  const handleTextChange = (value) => {
    setForm((prev) => ({
      ...prev,
      text: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      await updateHomeContent(form);
      setMessage('Home page content updated successfully.');
    } catch (error) {
      console.error('Failed to update home content:', error);
      setMessage('Failed to update home page content.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Manage Home Page Text</h1>

      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-2xl p-6 space-y-6">
        <div>
          <label className="block text-sm font-medium mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleTitleChange}
            className="w-full border rounded-lg px-4 py-2"
            placeholder="Enter homepage title"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">Text</label>
          <div className="bg-white">
            <ReactQuill
                theme="snow"
                value={form.text}
                onChange={handleTextChange}
                modules={quillModules}
                formats={quillFormats}
                />
          </div>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="bg-black text-white px-6 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </button>

        {message && <p className="text-sm mt-2">{message}</p>}
      </form>
    </div>
  );
};

export default AdminHomeContent;